import { render, staticRenderFns } from "./AddCartToast.vue?vue&type=template&id=196725f2&scoped=true"
var script = {}
import style0 from "./AddCartToast.vue?vue&type=style&index=0&id=196725f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196725f2",
  null
  
)

export default component.exports